<script>
import SlideShow from '@/components/slide-show/public/slide-show.vue'
import TwCard from '@/components/generic/tw-card.vue'
import FundraiserTabs from '@/components/fundraisers/public/fundraiser-tabs.vue'
import TwTabsNavigation from '@/components/generic/tabs/tw-tabs-navigation.vue'
import FundraiserAboutTabs from '@/components/fundraisers/public/fundraiser-about-tabs.vue'
import FundraiserSlideShow from '@/components/fundraisers/public/fundraiser-slide-show.vue'
import DonationsListGroup from '@/components/donations/public/donations-list-group.vue'

export default {
  name: 'FundraiserTeamLeftColumn',
  components: { DonationsListGroup, FundraiserSlideShow, FundraiserAboutTabs, FundraiserTabs },
  props: {
    fundraiser: {
      type: Object,
      required: true
    },
    team: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
   <div class="flex flex-col">
    <fundraiser-slide-show v-if="fundraiser.slideshow" :fundraiser="fundraiser" />
    <fundraiser-about-tabs :fundraiser="fundraiser" :team="team" class="mt-10" />
    <fundraiser-tabs :fundraiser="fundraiser" :team="team" class="mt-10"/>
    <donations-list-group :fundraiser="fundraiser" :team="team" class="mt-10 lg:hidden" />
  </div>
</template>

<style scoped>

</style>
